/**
 * Created by shubham on 13/6/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FileUploadRoutingModule } from './fileUpload-routing.module';
import { FileUploadComponent } from './fileUpload.component';
import { FileUploadListComponent } from './fileUploadList/fileUploadList.component';
import { AddFileComponent } from './add-file/addFile.component';
import { FileUploadModule } from "ng2-file-upload";
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { APPCONFIG } from '../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        ReactiveFormsModule,
        FileUploadModule,
        FileUploadRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+'/_ah/api/noAuthApi/v1/i18nJson', ''),
            deps: [Http]
        })
    ],
    declarations: [
        FileUploadComponent,
        FileUploadListComponent,
        AddFileComponent
    ],
    exports: [
    ]
})

export class CSVUploadModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUpload.module.ts